function alignmentToJustify(alignment) {
  if (alignment === 'left') {
    return 'flex-start'
  } else if (alignment === 'right') {
    return 'flex-end'
  }

  return 'center'
}

export default alignmentToJustify
